/**
 * pause-helpers - Utilitários para formatação de tempo de pausa
 * 
 * @version 1.0.0
 * RELEASE: 2026-04-11 v1.0.0 - Criação inicial
 */

/**
 * Formata duração em segundos para exibição legível
 * Exemplos: "2h 35m", "45m", "1d 3h", "—" (se null/0)
 * 
 * @param seconds - Duração em segundos (null = pausa ativa sem duração)
 */
export function formatPauseDuration(seconds: number | null | undefined): string {
  if (!seconds || seconds <= 0) return '—';

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  if (days > 0) {
    return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
  }
  if (hours > 0) {
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }
  return `${minutes}m`;
}

/**
 * Formata duração para exibição compacta (cronômetro na listagem)
 * Formato: HH:MM:SS ou MM:SS
 * 
 * @param seconds - Duração em segundos
 */
export function formatPauseTimer(seconds: number | null | undefined): string {
  if (!seconds || seconds <= 0) return '00:00';

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  if (h > 0) {
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
